export const sortersMap: {[key: string]: string} = {
  name: "Nome",
  startTimestamp: "Data di inizio",
  endTimestamp: "Data di fine",
  startSubscriptionTimestamp: "Data di inizio iscrizioni",
  endSubscriptionTimestamp: "Data di fine iscrizioni",
  creationTimestamp: "Data di creazione",
  lastEditTimestamp: "Ultima modifica",
  visibleTimestamp: "Data di pubblicazione",
  userId: "Id utente",
  challengeId: "Id challenge",
  score: "Punteggio",
  timestamp: "Data",
  teamId: "Id squadra",
  testingStatus: "Stato testing",
  taskId: "Id Task",
  id: "Id",
  firstname: "Nome",
  lastname: "Cognome",
  email: "Email",
  organizationName: "Nome organizzazione"
}

export const sortersValuesMap: {[key: string]: string} = {
  ASC: "Ascendente",
  DESC: "Discendente"
}